module.exports = __webpack_public_path__ + "static/media/sim1.31c3ce67.svg";